/**
 * LEGACY_DECOMMISSIONED (May 22, 2026)
 * Part of the legacy upload subsystem. Frozen. Do not extend.
 * Replacement: separate Video Analysis Engine (see VAE_CLEAN_ROOM_ARCHITECTURE.md).
 *
 * intakeLog.js — permanent lifecycle logger for the Safari-safe file
 * intake layer. May 21, 2026.
 *
 * Doctrine:
 *   • Synchronous. No async, no microtasks, no React.
 *   • Independent of every legacy picker bus (pickerDebug, pickerBeacon,
 *     pickerEvents). This file MUST stand alone so the intake layer
 *     can survive even if those legacy modules misbehave or get
 *     deleted in a later sweep.
 *   • Writes to a small bounded ring in localStorage AND to console.
 *   • Never throws. Never blocks the intake hot path.
 *
 * Events emitted by MobilePhotosIntake.jsx:
 *   intake_mounted
 *   intake_open_clicked
 *   intake_picker_returned        { count }
 *   intake_raw_file_captured      { idx, name, size, type, lastModified }
 *   intake_staged_inserted        { count }
 *   intake_stage_failed           { error }
 *   intake_input_cleared
 *
 * Read the log on the device via the dev panel at `?intakeLog=1` or
 * by calling `readIntakeLog()` from the browser console.
 */

const STORAGE_KEY = "ndg:intake-log:v1";
const MAX_ENTRIES = 200;

function _safe() {
  try { return typeof localStorage !== "undefined" ? localStorage : null; }
  catch (_) { return null; }
}

export function intakeLog(event, payload = {}) {
  const entry = {
    t: new Date().toISOString(),
    event,
    ...payload,
  };
  // 1) Console — always.
  try {
    // eslint-disable-next-line no-console
    console.info("[intake]", event, payload);
  } catch (_) { /* noop */ }
  // 2) localStorage ring — synchronous write so it survives a
  //    WKWebView eviction that hits the next React tick.
  const ss = _safe();
  if (!ss) return;
  try {
    const raw = ss.getItem(STORAGE_KEY);
    const arr = raw ? JSON.parse(raw) : [];
    arr.push(entry);
    while (arr.length > MAX_ENTRIES) arr.shift();
    ss.setItem(STORAGE_KEY, JSON.stringify(arr));
  } catch (_) { /* noop — quota / parse failure must not break intake */ }
}

export function readIntakeLog() {
  const ss = _safe();
  if (!ss) return [];
  try {
    const raw = ss.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch (_) { return []; }
}

export function clearIntakeLog() {
  const ss = _safe();
  if (!ss) return;
  try { ss.removeItem(STORAGE_KEY); } catch (_) { /* noop */ }
}
